import { render, staticRenderFns } from "./partner_detail_base_institutions.vue?vue&type=template&id=d3829e18&scoped=true"
import script from "./partner_detail_base_institutions.vue?vue&type=script&lang=js"
export * from "./partner_detail_base_institutions.vue?vue&type=script&lang=js"
import style0 from "./partner_detail_base_institutions.vue?vue&type=style&index=0&id=d3829e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3829e18",
  null
  
)

export default component.exports